/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Preset_Select_Aria_LabelInputs */

const en_styles_preset_select_aria_label = /** @type {(inputs: Styles_Preset_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style Preset Selection`)
};

const fr_styles_preset_select_aria_label = /** @type {(inputs: Styles_Preset_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selection de preset de style`)
};

const de_styles_preset_select_aria_label = /** @type {(inputs: Styles_Preset_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stilvoreinstellungsauswahl`)
};

const it_styles_preset_select_aria_label = /** @type {(inputs: Styles_Preset_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione predefinita di stile`)
};

const ru_styles_preset_select_aria_label = /** @type {(inputs: Styles_Preset_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор предустановленного стиля`)
};

const es_styles_preset_select_aria_label = /** @type {(inputs: Styles_Preset_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección de ajustes preestablecidos de estilo`)
};

const zh_cn2_styles_preset_select_aria_label = /** @type {(inputs: Styles_Preset_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`样式预设选择`)
};

const ja_styles_preset_select_aria_label = /** @type {(inputs: Styles_Preset_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルプリセットの選択`)
};

const hi_styles_preset_select_aria_label = /** @type {(inputs: Styles_Preset_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल प्रीसेट चयन`)
};

const pt_pt2_styles_preset_select_aria_label = /** @type {(inputs: Styles_Preset_Select_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção de predefinições de estilo`)
};

/**
* | output |
* | --- |
* | "Style Preset Selection" |
*
* @param {Styles_Preset_Select_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_preset_select_aria_label = /** @type {((inputs?: Styles_Preset_Select_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Preset_Select_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_preset_select_aria_label(inputs)
	if (locale === "de") return de_styles_preset_select_aria_label(inputs)
	if (locale === "it") return it_styles_preset_select_aria_label(inputs)
	if (locale === "ru") return ru_styles_preset_select_aria_label(inputs)
	if (locale === "es") return es_styles_preset_select_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_preset_select_aria_label(inputs)
	if (locale === "ja") return ja_styles_preset_select_aria_label(inputs)
	if (locale === "hi") return hi_styles_preset_select_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_preset_select_aria_label(inputs)
	return en_styles_preset_select_aria_label(inputs)
});